var ILLU = {coeur: "<svg viewBox='0 0 400 500' preserveAspectRatio='xMidYMid slice' role='img' aria-label='Un grand cœur rouge entouré de petits cœurs'><defs><linearGradient id='co-bg' x1='0' y1='0' x2='0' y2='1'><stop offset='0' stop-color='#FBE6E8'/><stop offset='1' stop-color='#EBA9B6'/></linearGradient><linearGradient id='co-h' x1='0' y1='0' x2='1' y2='1'><stop offset='0' stop-color='#E2405F'/><stop offset='1' stop-color='#8E1430'/></linearGradient></defs><rect width='400' height='500' fill='url(#co-bg)'/><g fill='#C21E3A' opacity='.22'><use href='#i-heart' x='50' y='90' width='34' height='34'/><use href='#i-heart' x='316' y='120' width='26' height='26'/><use href='#i-heart' x='40' y='380' width='26' height='26'/><use href='#i-heart' x='320' y='400' width='40' height='40'/><use href='#i-heart' x='180' y='60' width='20' height='20'/></g><path d='M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z' transform='translate(56 124.6) scale(12)' fill='none' stroke='#C9A24D' stroke-width='.11'/><path d='M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z' transform='translate(70.4 138.4) scale(10.8)' fill='url(#co-h)'/><ellipse cx='148' cy='214' rx='28' ry='15' transform='rotate(-35 148 214)' fill='#fff' opacity='.28'/><g fill='#F7E3AD'><path transform='translate(96 150) scale(1.1)' d='M0 -10 L2.5 -2.5 L10 0 L2.5 2.5 L0 10 L-2.5 2.5 L-10 0 L-2.5 -2.5 Z'/><path transform='translate(318 300) scale(.8)' d='M0 -10 L2.5 -2.5 L10 0 L2.5 2.5 L0 10 L-2.5 2.5 L-10 0 L-2.5 -2.5 Z'/><path transform='translate(120 420) scale(.6)' d='M0 -10 L2.5 -2.5 L10 0 L2.5 2.5 L0 10 L-2.5 2.5 L-10 0 L-2.5 -2.5 Z'/><path transform='translate(290 80) scale(.6)' d='M0 -10 L2.5 -2.5 L10 0 L2.5 2.5 L0 10 L-2.5 2.5 L-10 0 L-2.5 -2.5 Z'/></g></svg>"};
(function () {
'use strict';
var D = window.COUPLE || {};
var PREVIEW = window.PREVIEW || {};
var doc = document, root = doc.documentElement;
root.classList.remove('no-js');
var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var LANG = D.langue === 'en' ? 'en' : 'fr';
root.lang = LANG;
var STY = D.style || { bordeaux: 'lettre', nuit: 'etoiles', sauge: 'jardin' }[D.theme] || 'lettre';
var SC = {
lettre: { frame: 'arch', orn: 'star', parts: 'petals', bloom: [[225, 255], [40, 150], [90, 150]] },
etoiles: { frame: 'circle', orn: 'halo', parts: 'stars', bloom: [[205, 255], [160, 220], [175, 240]] },
jardin: { frame: 'oval', orn: 'none', parts: 'petals', bloom: [[200, 245], [150, 220], [120, 170]] },
polaroid: { frame: 'polaroid', orn: 'none', parts: 'petals', bloom: [[230, 255], [150, 225], [170, 225]] },
cinema: { frame: 'film', orn: 'none', parts: 'stars', bloom: [[215, 255], [70, 175], [45, 110]] },
minimal: { frame: 'rect', orn: 'none', parts: 'none', bloom: [[220, 255], [120, 175], [100, 150]] },
fun: { frame: 'blob', orn: 'none', parts: 'confetti', bloom: [[235, 255], [70, 175], [130, 210]] },
gaming: { frame: 'pixel', orn: 'none', parts: 'pixels', bloom: [[230, 255], [30, 120], [150, 235]] }
}[STY];
if (!SC) { STY = 'lettre'; SC = { frame: 'arch', orn: 'star', parts: 'petals', bloom: [[225, 255], [40, 150], [90, 150]] }; }
root.classList.add('style-' + STY);

var NN = ' ';
var T = {
fr: {
y: function (n) { return n + (n > 1 ? ' ans' : ' an'); },
m: function (n) { return n + ' mois'; },
d: function (n) { return n + (n > 1 ? ' jours' : ' jour'); },
and: ' et ', intro: function (p) { return p + ', j’ai préparé quelque chose pour toi.'; },
open: 'Ouvrir ta lettre', hint: 'Monte le son' + NN + ': notre chanson est à l’intérieur.', to: function (p) { return 'Pour ' + p; },
since: function (d) { return 'Ensemble depuis le ' + d + '.'; },
lead: function (p) { return p + ', je t’aime depuis'; }, days: 'jours', clock: ['h', 'min', 's'],
sum: function (x) { return 'Soit ' + x + ' à tes côtés.'; }, few: 'quelques heures',
married: 'Mariés depuis', soon: 'Bientôt',
together: 'ensemble', marriedW: 'de mariage',
anniv: function (x, what, date, days) { return x + ' ' + what + ' le ' + date + ', ' + (days === 1 ? 'demain.' : 'dans ' + this.d(days) + '.'); },
today: function (x, what) { return 'Aujourd’hui' + NN + ': ' + x + ' ' + what + '.'; },
noteT: function (x) { return 'Joyeux anniversaire, mon amour. ' + x + ' ensemble aujourd’hui.'; },
noteM: function (x) { return 'Joyeux anniversaire de mariage. ' + x + ' aujourd’hui.'; },
story: 'Notre histoire', nextDate: 'Aujourd’hui, et tous les jours d’après', nextTitle: 'La page suivante',
nextText: 'Toutes les pages après celle-ci sont encore blanches. Où que la vie nous emmène, je veux les écrire avec toi.',
gallery: 'Nos souvenirs', prev: 'Photo précédente', next: 'Photo suivante', show: function (i) { return 'Voir la photo ' + i; },
why: 'Pourquoi toi' + NN + '?', tap: 'Touche la carte pour une autre raison.', another: 'Une autre raison', restart: 'Recommencer',
of: function (n) { return 'sur ' + n; }, more: 'Et mille autres que je n’ai pas encore écrites.', counting: 'et ça continue',
letter: 'Une lettre pour toi', readAll: 'Lire toute la lettre', promises: 'Ce que je te promets',
capsuleWhen: function (d) { return 'Elle s’ouvrira le ' + d + '.'; }, cdLabels: ['jours', 'h', 'min', 's'],
capsuleOpen: 'Ouvrir la capsule', capsuleReady: 'Le jour est arrivé.',
back: 'Revenir au début', song: function (t) { return 'Notre chanson' + NN + ': ' + t; }, play: 'Lancer notre chanson', pause: 'Mettre en pause'
},
en: {
y: function (n) { return n + (n === 1 ? ' year' : ' years'); },
m: function (n) { return n + (n === 1 ? ' month' : ' months'); },
d: function (n) { return n + (n === 1 ? ' day' : ' days'); },
and: ' and ', intro: function (p) { return p + ', I made something for you.'; },
open: 'Open your letter', hint: 'Turn the sound on, our song is inside.', to: function (p) { return 'For ' + p; },
since: function (d) { return 'You and me, since ' + d + '.'; },
lead: function (p) { return p + ', I have loved you for'; }, days: 'days', clock: ['h', 'min', 's'],
sum: function (x) { return 'That’s ' + x + ' of you.'; }, few: 'a few hours',
married: 'Married for', soon: 'Coming up',
together: 'together', marriedW: 'married',
anniv: function (x, what, date, days) { return x + ' ' + what + ' on ' + date + ', ' + (days === 1 ? 'tomorrow.' : 'in ' + this.d(days) + '.'); },
today: function (x, what) { return 'Today: ' + x + ' ' + what + '.'; },
noteT: function (x) { return 'Happy anniversary, my love. ' + x + ' together today.'; },
noteM: function (x) { return 'Happy wedding anniversary. ' + x + ' today.'; },
story: 'Our story so far', nextDate: 'Today, and every day after', nextTitle: 'The next page',
nextText: 'Every page after this one is still blank. Wherever life takes us, I want to write them all with you.',
gallery: 'Our memories', prev: 'Previous photo', next: 'Next photo', show: function (i) { return 'Show photo ' + i; },
why: 'Why you?', tap: 'Tap the card for another reason.', another: 'Another reason', restart: 'Start again',
of: function (n) { return 'of ' + n; }, more: 'And a thousand more I haven’t written down yet.', counting: 'and counting',
letter: 'A letter for you', readAll: 'Read the whole letter', promises: 'What I promise you',
capsuleWhen: function (d) { return 'It will open on ' + d + '.'; }, cdLabels: ['days', 'h', 'min', 's'],
capsuleOpen: 'Open the time capsule', capsuleReady: 'The day has come.',
back: 'Back to the beginning', song: function (t) { return 'Our song: ' + t; }, play: 'Play our song', pause: 'Pause our song'
}
}[LANG];
var X = {
fr: { kick: { etoiles: 'Sous les mêmes étoiles', jardin: 'Notre jardin secret', polaroid: 'Notre album', cinema: 'Un film de §', fun: 'Toi + moi = ♥', gaming: 'Player 1 + Player 2' },
cinemaSince: function (d) { return 'À l’affiche depuis le ' + d + '.'; }, ourSong: 'Notre chanson', ytTitle: 'Lecteur de notre chanson',
per: {
fun: { open: 'Ouvrir ma surprise', intro: function (p) { return p + ', j’ai une surprise rien que pour toi !'; } },
gaming: { open: '▶ Appuie sur Start', intro: function (p) { return p + ', une nouvelle partie t’attend.'; }, since: function (d) { return 'Partie commencée le ' + d + '.'; },
story: 'Niveaux débloqués', nextTitle: 'Niveau suivant', nextText: 'Le prochain niveau, on le joue ensemble. En coop, pour toujours.', back: 'Rejouer depuis le début' }
} },
en: { kick: { etoiles: 'Under the same stars', jardin: 'Our secret garden', polaroid: 'Our album', cinema: 'A film by §', fun: 'You + me = ♥', gaming: 'Player 1 + Player 2' },
cinemaSince: function (d) { return 'Now showing since ' + d + '.'; }, ourSong: 'Our song', ytTitle: 'Our song player',
per: {
fun: { open: 'Open my surprise', intro: function (p) { return p + ', I made a surprise just for you!'; } },
gaming: { open: '▶ Press Start', intro: function (p) { return p + ', a new game is waiting for you.'; }, since: function (d) { return 'Game started on ' + d + '.'; },
story: 'Levels unlocked', nextTitle: 'Next level', nextText: 'We’ll play the next level together. Co-op, forever.', back: 'Play again from the start' }
} }
}[LANG];
(function (o) { if (o) Object.keys(o).forEach(function (k) { T[k] = o[k]; }); })(X.per[STY]);

function $(s, r) { return (r || doc).querySelector(s); }
function $$(s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); }
function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
function br(s) { return esc(s).replace(/\n/g, '<br>'); }
function rf(a, b) { return a + Math.random() * (b - a); }
function ri(a, b) { return Math.floor(rf(a, b + 1)); }
function pad(n) { return n < 10 ? '0' + n : '' + n; }
function parseDate(s) {
if (!s) return null;
var m = String(s).match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/);
if (!m) return null;
return new Date(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0), 0);
}
var fmtLong = new Intl.DateTimeFormat(LANG === 'fr' ? 'fr-FR' : 'en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
var fmtShort = new Intl.DateTimeFormat(LANG === 'fr' ? 'fr-FR' : 'en-GB', { day: 'numeric', month: 'long' });
function joinAnd(parts) {
parts = parts.filter(Boolean);
if (parts.length < 2) return parts[0] || '';
return parts.slice(0, -1).join(', ') + T.and + parts[parts.length - 1];
}
function ymd(from, to) {
var y = to.getFullYear() - from.getFullYear(), m = to.getMonth() - from.getMonth(), d = to.getDate() - from.getDate();
var tf = from.getHours() * 3600 + from.getMinutes() * 60, tt = to.getHours() * 3600 + to.getMinutes() * 60 + to.getSeconds();
if (tt < tf) d--;
if (d < 0) { m--; d += new Date(to.getFullYear(), to.getMonth(), 0).getDate(); }
if (m < 0) { y--; m += 12; }
return joinAnd([y ? T.y(y) : '', m ? T.m(m) : '', d ? T.d(d) : '']) || T.few;
}
var ARCH_PATH = 'M0.07,1 L0.07,0.52 C0.07,0.47 0,0.44 0,0.36 C0,0.17 0.22,0.07 0.5,0 C0.78,0.07 1,0.17 1,0.36 C1,0.44 0.93,0.47 0.93,0.52 L0.93,1';
function picture(photo, illu, alt, eager) {
if (photo) return '<img src="' + esc(photo) + '" alt="' + esc(alt || '') + '"' + (eager ? '' : ' loading="lazy"') + ' decoding="async">';
return (window.ILLU && ILLU[illu]) || ILLU.coeur;
}
var OVAL_PATH = 'M0.5,0 C0.776,0 1,0.224 1,0.5 C1,0.776 0.776,1 0.5,1 C0.224,1 0,0.776 0,0.5 C0,0.224 0.224,0 0.5,0 Z';
function arch(photo, illu, alt, eager, cap) {
var f = SC.frame, inner = '<div class="arch-in">' + picture(photo, illu, alt, eager) + '</div>';
function line(d) { return '<svg class="arch-line" viewBox="0 0 1 1" preserveAspectRatio="none" aria-hidden="true"><path d="' + d + '"/></svg>'; }
if (f === 'arch') return '<figure class="arch frame-arch">' + inner + line(ARCH_PATH) + '</figure>';
if (f === 'circle' || f === 'oval') return '<figure class="arch frame-' + f + '">' + inner + line(OVAL_PATH) + '</figure>';
if (f === 'polaroid') return '<figure class="arch frame-polaroid">' + inner + (cap ? '<figcaption>' + esc(cap) + '</figcaption>' : '') + '</figure>';
return '<figure class="arch frame-' + f + '">' + inner + '</figure>';
}
function ytId(u) {
u = String(u || '').trim(); if (!u) return '';
if (/^[\w-]{11}$/.test(u)) return u;
var m = u.match(/(?:youtu\.be\/|[?&]v=|\/embed\/|\/shorts\/|\/live\/)([\w-]{11})/);
return m ? m[1] : '';
}
function paras(list) { return (list || []).filter(function (p) { return String(p).trim(); }).map(function (p) { return '<p>' + br(p) + '</p>'; }).join(''); }
var STAR = '<svg aria-hidden="true"><use href="#i-star"/></svg>';

var de = D.de || '', pour = D.pour || '';
var start = parseDate(D.depuis) || new Date();
var wed = parseDate(D.mariage);
var hist = (D.histoire || []).filter(function (h) { return h && (h.titre || h.texte || h.photo); });
var gal = [], galCap = [], galNotes = (D.galerie && D.galerie.notes) || [];
((D.galerie && D.galerie.photos) || []).forEach(function (p, i) { if (p) { gal.push(p); galCap.push(String(galNotes[i] || '').trim()); } });
var reasons = (D.raisons || []).filter(function (r) { return String(r).trim(); });
var promises = (D.promesses || []).filter(function (r) { return String(r).trim(); });
var L = D.lettre || {};
var letterParas = (L.paragraphes || []).filter(function (p) { return String(p).trim(); });
var cap = D.capsule && D.capsule.date ? D.capsule : null;
var F = D.final || {};
var MU = D.musique || {};
var song = MU.url ? MU : null;
var YT = ytId(MU.youtube);
var songName = [MU.titre, MU.artiste].filter(function (x) { return x && String(x).trim(); }).join(' — ');
var playable = !!(song || YT);
var heroPhoto = D.photoPrincipale || null;
var showIntro = !PREVIEW.skipIntro && D.intro !== false;

var h = [];
h.push('<svg class="sprite" aria-hidden="true" focusable="false"><defs><clipPath id="arch-clip" clipPathUnits="objectBoundingBox"><path d="M0.07,1 L0.07,0.52 C0.07,0.47 0,0.44 0,0.36 C0,0.17 0.22,0.07 0.5,0 C0.78,0.07 1,0.17 1,0.36 C1,0.44 0.93,0.47 0.93,0.52 L0.93,1 Z"/></clipPath>' +
'<symbol id="i-heart" viewBox="0 0 24 24"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></symbol>' +
'<symbol id="i-star" viewBox="0 0 20 20"><rect x="4" y="4" width="12" height="12"/><rect x="4" y="4" width="12" height="12" transform="rotate(45 10 10)"/></symbol></defs></svg>');

if (showIntro) {
h.push('<div class="intro dark" id="intro" role="dialog" aria-modal="true" aria-label="' + esc(T.to(D.surnom || pour)) + '"><canvas id="petals" aria-hidden="true"></canvas><div class="intro-inner">' +
'<div class="envelope" aria-hidden="true"><div class="env-back"></div><div class="env-letter"><span>' + esc(D.phrase || (de + ' & ' + pour)) + '</span></div>' +
'<div class="env-front"><span class="to">' + esc(T.to(D.surnom || pour)) + '</span></div><div class="env-flap"></div><div class="seal">' + esc(D.sceau || (de.charAt(0) + '&' + pour.charAt(0))) + '</div></div>' +
'<p class="intro-note">' + esc(T.intro(D.surnom || pour)) + '</p><button class="btn on-dark" id="open-letter" type="button">' + esc(T.open) + '</button>' +
(playable ? '<p class="intro-hint">' + esc(T.hint) + '</p>' : '') + '</div></div>');
} else { doc.body.classList.remove('locked'); }

var kick = X.kick[STY] ? X.kick[STY].replace('§', de) : '';
var orn = SC.orn === 'star' ? '<svg class="hero-star" viewBox="0 0 100 100" aria-hidden="true"><rect x="21" y="21" width="58" height="58"/><rect x="21" y="21" width="58" height="58" transform="rotate(45 50 50)"/><circle cx="50" cy="50" r="46"/></svg>'
: SC.orn === 'halo' ? '<svg class="hero-star" viewBox="0 0 100 100" aria-hidden="true"><circle cx="50" cy="50" r="46"/><circle cx="50" cy="50" r="41"/></svg>' : '';
h.push('<main><header class="hero" id="top"><div class="hero-grid"><div class="hero-photo">' + orn +
arch(heroPhoto, D.illustrationPrincipale || 'coeur', de + ' & ' + pour, true, de + ' & ' + pour) + '</div><div class="hero-text">' +
(kick ? '<p class="kicker">' + esc(kick) + '</p>' : '') +
'<h1 class="names" tabindex="-1" id="names"><span>' + esc(de) + '</span><span>&amp; ' + esc(pour) + '</span></h1>' +
(D.phrase ? '<p class="song-line">' + esc(D.phrase) + '</p>' : '') +
'<p class="since">' + esc((STY === 'cinema' ? X.cinemaSince : T.since)(fmtLong.format(start))) + '</p>' +
(songName ? '<p class="song-name"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 18.5a2.5 2.5 0 1 1-2-2.45V5.5l12-2.5v12.5a2.5 2.5 0 1 1-2-2.45V7.3l-8 1.7v9.5z"/></svg><span>' + esc(X.ourSong + (LANG === 'fr' ? NN + ': ' : ': ') + songName) + '</span></p>' : '') +
'<p class="anniv-note" id="anniv-note"></p></div></div></header>');

h.push('<section class="loved dark" id="loved" aria-label="' + esc(T.lead(pour)) + '"><div class="loved-grid"><div class="heart-wrap"><canvas id="garden" aria-hidden="true"></canvas>' +
'<div class="heart-words" id="heart-words"><p class="hw-lead">' + esc(T.lead(pour)) + '</p><p class="hw-days"><span id="c-days">0</span><small>' + esc(T.days) + '</small></p>' +
'<p class="hw-clock"><span id="c-h">00</span> ' + T.clock[0] + ' <span id="c-m">00</span> ' + T.clock[1] + ' <span id="c-s">00</span> ' + T.clock[2] + '</p></div></div>' +
'<div class="loved-after"><p class="loved-sum">' + esc(T.sum('§')).replace('§', '<span id="c-ymd"></span>') + '</p><div class="loved-meta' + (wed ? ' two' : '') + '">' +
(wed ? '<div><h3>' + esc(T.married) + '</h3><p id="c-married"></p></div>' : '') +
'<div><h3>' + esc(T.soon) + '</h3><p id="c-next1"></p>' + (wed ? '<p id="c-next2"></p>' : '') + '</div></div></div></div></section>');

if (YT) {
h.push('<section class="song-section dark" aria-labelledby="song-title"><div class="section-head"><h2 class="section-title" id="song-title">' + esc(X.ourSong) + '</h2></div>' +
'<div class="yt"><iframe id="yt" src="https://www.youtube-nocookie.com/embed/' + YT + '?enablejsapi=1&amp;playsinline=1&amp;rel=0" title="' + esc(X.ytTitle) + '" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe></div>' +
(MU.titre ? '<p class="song-title">' + esc(MU.titre) + '</p>' : '') + (MU.artiste ? '<p class="song-artist">' + esc(MU.artiste) + '</p>' : '') + '</section>');
}

if (hist.length) {
h.push('<section class="story-section" aria-labelledby="story-title"><div class="section-head"><h2 class="section-title" id="story-title">' + esc((D.titres && D.titres.histoire) || T.story) + '</h2></div><ol class="story">');
hist.forEach(function (m, i) {
h.push('<li class="moment' + (i % 2 ? ' flip' : '') + '">' + arch(m.photo, m.illustration || 'coeur', m.titre, false, m.date || m.titre) +
'<div class="moment-text">' + (m.date ? '<p class="date">' + esc(m.date) + '</p>' : '') + (m.titre ? '<h3>' + esc(m.titre) + '</h3>' : '') + (m.texte ? '<p>' + br(m.texte) + '</p>' : '') + '</div></li>');
});
var S = D.suite || {};
h.push('<li class="moment next"><div class="moment-text"><svg class="star-mark" aria-hidden="true"><use href="#i-star"/></svg><p class="date">' + esc(S.date || T.nextDate) + '</p><h3>' + esc(S.titre || T.nextTitle) + '</h3><p>' + br(S.texte || T.nextText) + '</p></div></li></ol></section>');
}

if (gal.length) {
h.push('<section class="gallery-section" aria-label="' + esc((D.galerie && D.galerie.titre) || T.gallery) + '"><div class="section-head"><h2 class="section-title">' + esc((D.galerie && D.galerie.titre) || T.gallery) + '</h2></div>' +
'<div class="gallery" id="gallery" role="region" aria-roledescription="carousel"><div class="slides" id="slides">');
gal.forEach(function (src, i) {
h.push('<figure class="slide' + (i ? '' : ' is-active') + '" aria-roledescription="slide" aria-label="' + (i + 1) + ' / ' + gal.length + '"' + (i ? ' aria-hidden="true"' : '') + '><img class="bg" src="' + esc(src) + '" alt="" loading="lazy" decoding="async"><img class="fg" src="' + esc(src) + '" alt="' + esc(galCap[i]) + '" loading="lazy" decoding="async">' + (galCap[i] ? '<figcaption class="slide-cap">' + br(galCap[i]) + '</figcaption>' : '') + '</figure>');
});
h.push((gal.length > 1 ? '<button class="g-btn g-prev" type="button" aria-label="' + esc(T.prev) + '"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M10 3 L5 8 L10 13"/></svg></button><button class="g-btn g-next" type="button" aria-label="' + esc(T.next) + '"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M6 3 L11 8 L6 13"/></svg></button>' : '') + '</div>');
if (gal.length > 1) {
h.push('<div class="thumbs">');
gal.forEach(function (src, i) { h.push('<button class="thumb" type="button" aria-label="' + esc(T.show(i + 1)) + '"' + (i ? '' : ' aria-current="true"') + '><img src="' + esc(src) + '" alt="" loading="lazy"></button>'); });
h.push('</div>');
}
h.push('</div></section>');
}

if (reasons.length) {
h.push('<section class="reasons" aria-labelledby="reasons-title"><div class="section-head"><h2 class="section-title" id="reasons-title">' + esc(T.why) + '</h2><p>' + esc(T.tap) + '</p></div>' +
'<div class="deck"><div class="deck-back b1"></div><div class="deck-back b2"></div><button class="card" id="card" type="button"><span class="card-top"><span class="card-no" id="card-no">1</span><span class="card-of" id="card-of"></span></span>' +
'<span class="card-text" id="card-text" aria-live="polite"></span><svg class="card-heart" aria-hidden="true"><use href="#i-heart"/></svg></button></div><button class="btn" id="next-reason" type="button">' + esc(T.another) + '</button></section>');
}

if (letterParas.length) {
h.push('<section class="letter-section dark" aria-labelledby="letter-title"><div class="section-head"><h2 class="section-title" id="letter-title">' + esc(T.letter) + '</h2></div>' +
'<article class="letter folded" id="letter">' + (L.salutation ? '<p class="salutation">' + esc(L.salutation) + '</p>' : '') + paras(letterParas) +
(L.signature ? '<p class="sign">' + esc(L.signature) + '</p>' : '') + '</article><div class="unfold-row" id="unfold-row"><button class="btn on-dark" id="unfold" type="button" aria-expanded="false" aria-controls="letter">' + esc(T.readAll) + '</button></div></section>');
}

if (promises.length) {
h.push('<section class="promises-section" aria-labelledby="promises-title"><div class="section-head"><h2 class="section-title" id="promises-title">' + esc(T.promises) + '</h2></div><ul class="promises">' +
promises.map(function (p) { return '<li>' + STAR + '<span>' + br(p) + '</span></li>'; }).join('') + '</ul></section>');
}

if (cap) {
var capDate = parseDate(cap.date);
h.push('<section class="capsule dark" aria-labelledby="cap-title"><div class="lock" aria-hidden="true"><svg viewBox="0 0 24 24"><rect x="5" y="10.5" width="14" height="10" rx="2"/><path d="M8 10.5V7.5a4 4 0 0 1 8 0v3"/></svg></div>' +
'<h2 class="section-title" id="cap-title">' + esc(cap.titre || '') + '</h2><p class="capsule-when" id="cap-when">' + esc(T.capsuleWhen(fmtLong.format(capDate || new Date()))) + '</p>' +
'<div class="countdown" id="countdown">' + T.cdLabels.map(function (l, i) { return '<div><b data-i="' + i + '">0</b><span>' + esc(l) + '</span></div>'; }).join('') + '</div>' +
'<button class="btn on-dark" id="cap-open" type="button" hidden>' + esc(T.capsuleOpen) + '</button>' +
'<article class="letter" id="cap-letter" hidden>' + paras(String(cap.message || '').split(/\n\s*\n/)) + (cap.signature ? '<p class="sign">' + esc(cap.signature) + '</p>' : '') + '</article></section>');
}

h.push('<footer class="finale"><p class="forever">' + esc(F.phrase || (LANG === 'fr' ? 'Je t’aime pour toujours.' : 'Love you forever and ever.')) + '</p>' +
'<p class="sig">' + esc(F.signature || de) + '</p>' +
(F.ligne ? '<p class="extra-line" dir="auto">' + esc(F.ligne) + '</p>' : '') + (F.traduction ? '<p class="extra-sub">' + esc(F.traduction) + '</p>' : (F.ligne ? '<p class="extra-sub"></p>' : '')) +
'<a class="again" href="#top">' + esc(T.back) + '</a></footer></main>');

if (playable) {
h.push('<button class="disc" id="disc" type="button" aria-label="' + esc(T.play) + '"><span class="face">' + (heroPhoto ? '<img src="' + esc(heroPhoto) + '" alt="">' : ILLU[D.illustrationPrincipale || 'coeur']) + '</span>' +
'<svg class="ring" viewBox="0 0 72 72" aria-hidden="true"><circle class="track" cx="36" cy="36" r="34"/><circle class="bar" id="disc-bar" cx="36" cy="36" r="34" stroke-dasharray="213.6" stroke-dashoffset="213.6"/></svg>' +
'<span class="icon" aria-hidden="true"><svg class="i-play" viewBox="0 0 14 14"><path d="M3 1.5 L12 7 L3 12.5 Z"/></svg><svg class="i-pause" viewBox="0 0 14 14"><rect x="2.5" y="1.5" width="3" height="11" rx="1"/><rect x="8.5" y="1.5" width="3" height="11" rx="1"/></svg></span></button>' +
'<div class="disc-label" id="disc-label" aria-hidden="true">' + esc(T.song(songName || MU.titre || '')) + '</div>' +
(song ? '<audio id="song" preload="none" loop>' + [].concat(song.url).filter(Boolean).map(function (u) { return '<source src="' + esc(u) + '" type="audio/mpeg">'; }).join('') + '</audio>' : ''));
}
$('#app').innerHTML = h.join('');
if (!$('#app').firstChild) return;

var audio = $('#song'), disc = $('#disc'), ytF = $('#yt'), playSong = function () {};
if (disc) {
var discLabel = $('#disc-label'), bar = $('#disc-bar'), RING = 2 * Math.PI * 34, labelShown = false, isPlaying = false;
var setPlaying = function (on) {
isPlaying = on; disc.classList.toggle('playing', on); disc.setAttribute('aria-label', on ? T.pause : T.play);
if (on && !labelShown) { labelShown = true; discLabel.classList.add('show'); setTimeout(function () { discLabel.classList.remove('show'); }, 4500); }
};
if (audio) {
playSong = function () { try { var p = audio.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {} };
var srcs = audio.querySelectorAll('source');
srcs[srcs.length - 1].addEventListener('error', function () { disc.hidden = true; discLabel.hidden = true; });
audio.addEventListener('play', function () { setPlaying(true); });
audio.addEventListener('pause', function () { setPlaying(false); });
audio.addEventListener('timeupdate', function () { if (audio.duration && isFinite(audio.duration)) bar.style.strokeDashoffset = RING * (1 - audio.currentTime / audio.duration); });
disc.addEventListener('click', function () { audio.paused ? playSong() : audio.pause(); });
} else if (ytF) {
var ytReady = false, ytQueue = '';
var ytCmd = function (f) { try { ytF.contentWindow.postMessage(JSON.stringify({ event: 'command', func: f, args: [] }), '*'); } catch (e) {} };
ytF.addEventListener('load', function () {
ytReady = true;
try { ytF.contentWindow.postMessage(JSON.stringify({ event: 'listening', id: 'yt' }), '*'); } catch (e) {}
if (ytQueue) { ytCmd(ytQueue); ytQueue = ''; }
});
window.addEventListener('message', function (e) {
if (!/youtube/.test(e.origin)) return;
var m; try { m = typeof e.data === 'string' ? JSON.parse(e.data) : e.data; } catch (x) { return; }
var stt = m && m.info && m.info.playerState;
if (stt === 1) setPlaying(true); else if (stt === 2 || stt === 0) setPlaying(false);
});
playSong = function () { if (ytReady) ytCmd('playVideo'); else ytQueue = 'playVideo'; };
disc.addEventListener('click', function () { if (isPlaying) { ytCmd('pauseVideo'); setPlaying(false); } else { playSong(); setPlaying(true); } });
}
}

var intro = $('#intro');
if (intro) {
var petals = (function () {
var c = $('#petals'), ctx = c.getContext('2d'), list = [], raf = 0, w = 0, hh = 0;
var stars = SC.parts === 'stars', conf = SC.parts === 'confetti', pix = SC.parts === 'pixels', cs = getComputedStyle(root);
var colors = pix ? ['#FF2E88', '#00E5FF', '#FFE600', '#7CFF4F'] : conf ? [cs.getPropertyValue('--accent').trim(), '#FFB800', '#5BC0EB', '#7BD389', '#B78BFF', '#FF8FB1'] : (stars ? [cs.getPropertyValue('--gold-soft'), cs.getPropertyValue('--on-dark-strong'), cs.getPropertyValue('--gold')] : [cs.getPropertyValue('--accent'), cs.getPropertyValue('--tap'), cs.getPropertyValue('--blush'), cs.getPropertyValue('--gold-soft')]).map(function (x) { return x.trim(); });
function size() { var dpr = Math.min(window.devicePixelRatio || 1, 2); w = c.clientWidth; hh = c.clientHeight; c.width = w * dpr; c.height = hh * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
function make(top) { return { x: rf(0, w), y: top ? -20 : rf(0, hh), s: rf(5, 11), v: rf(.35, 1), a: rf(0, 6.28), va: rf(-.02, .02), sw: rf(.4, 1.2), ph: rf(0, 6.28), col: colors[ri(0, colors.length - 1)], o: rf(.35, .8) }; }
function frame(t) {
ctx.clearRect(0, 0, w, hh);
for (var i = 0; i < list.length; i++) {
var p = list[i];
if (pix) {
p.y += p.v * .45; if (p.y > hh + 20) list[i] = p = make(true);
var q = Math.max(3, Math.round(p.s * .7));
ctx.globalAlpha = p.o * (.45 + .55 * (Math.sin(t / 260 + p.ph) > 0 ? 1 : .35)); ctx.fillStyle = p.col;
ctx.fillRect(Math.round(p.x / 4) * 4, Math.round(p.y / 4) * 4, q, q); continue;
}
if (conf) {
p.y += p.v * 1.1; p.a += p.va * 4; p.x += Math.sin(t / 900 + p.ph) * p.sw * .5;
if (p.y > hh + 20) list[i] = p = make(true);
ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.a); ctx.globalAlpha = p.o + .15; ctx.fillStyle = p.col;
ctx.fillRect(-p.s * .5, -p.s * .22, p.s, p.s * .44 * Math.abs(Math.cos(t / 300 + p.ph)) + 1.5); ctx.restore(); continue;
}
if (stars) {
p.y += p.v * .18; if (p.y > hh + 20) list[i] = p = make(true);
ctx.globalAlpha = p.o * (.35 + .65 * Math.abs(Math.sin(t / 900 + p.ph))); ctx.fillStyle = p.col;
ctx.beginPath(); ctx.arc(p.x, p.y, p.s * .2, 0, Math.PI * 2); ctx.fill(); continue;
}
p.y += p.v; p.a += p.va; p.x += Math.sin(t / 1400 + p.ph) * p.sw * .35;
if (p.y > hh + 20) list[i] = p = make(true);
ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.a); ctx.globalAlpha = p.o; ctx.fillStyle = p.col;
ctx.beginPath(); ctx.ellipse(0, 0, p.s, p.s * .55, 0, 0, Math.PI * 2); ctx.fill(); ctx.restore();
}
raf = requestAnimationFrame(frame);
}
return {
start: function () { if (reduce || SC.parts === 'none') return; size(); for (var i = 0; i < (stars ? 70 : pix ? 46 : conf ? 44 : 26); i++) list.push(make(false)); window.addEventListener('resize', size); raf = requestAnimationFrame(frame); },
stop: function () { cancelAnimationFrame(raf); window.removeEventListener('resize', size); }
};
})();
petals.start();
var openBtn = $('#open-letter');
openBtn.focus({ preventScroll: true });
openBtn.addEventListener('click', function () {
if (intro.classList.contains('opening')) return;
intro.classList.add('opening'); playSong();
setTimeout(function () {
intro.classList.add('gone'); doc.body.classList.remove('locked');
$('#names').focus({ preventScroll: true }); setTimeout(petals.stop, 1100);
}, reduce ? 0 : 1900);
});
}

function nextAnniv(date, now) {
var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
var d = new Date(now.getFullYear(), date.getMonth(), date.getDate());
if (d < today) d = new Date(now.getFullYear() + 1, date.getMonth(), date.getDate());
return { days: Math.round((d - today) / 864e5), years: d.getFullYear() - date.getFullYear(), label: fmtShort.format(d) };
}
function line(a, what) { return a.days === 0 ? T.today(T.y(a.years), what) : T.anniv(T.y(a.years), what, a.label, a.days); }
var el = { days: $('#c-days'), h: $('#c-h'), m: $('#c-m'), s: $('#c-s'), ymd: $('#c-ymd'), married: $('#c-married'), n1: $('#c-next1'), n2: $('#c-next2'), note: $('#anniv-note') };
var lastDay = -1;
function tick() {
var now = new Date(), diff = Math.max(0, now - start), days = Math.floor(diff / 864e5), rem = diff - days * 864e5;
el.days.textContent = days.toLocaleString(LANG === 'fr' ? 'fr-FR' : 'en-US');
el.h.textContent = pad(Math.floor(rem / 36e5)); el.m.textContent = pad(Math.floor(rem % 36e5 / 6e4)); el.s.textContent = pad(Math.floor(rem % 6e4 / 1e3));
if (now.getDate() !== lastDay) {
lastDay = now.getDate();
el.ymd.textContent = ymd(start, now);
var a = nextAnniv(start, now), lines = [[a, line(a, T.together)]], note = '';
if (a.days === 0 && a.years > 0) note = T.noteT(T.y(a.years));
if (wed) {
el.married.textContent = ymd(wed, now);
var b = nextAnniv(wed, now); lines.push([b, line(b, T.marriedW)]);
if (b.days === 0 && b.years > 0) note = T.noteM(T.y(b.years));
}
lines.sort(function (x, y) { return x[0].days - y[0].days; });
el.n1.textContent = lines[0][1]; if (el.n2) el.n2.textContent = lines[1] ? lines[1][1] : '';
el.note.textContent = note; el.note.classList.toggle('show', !!note);
}
}
tick(); setInterval(tick, 1000);

var BLOOM = SC.bloom;
var garden = (function () {
var c = $('#garden'), ctx = c.getContext('2d'), blooms = [], W = 0, S = 0, K = 1, CX = 0, CY = 0, raf = 0;
function size() {
var dpr = Math.min(window.devicePixelRatio || 1, 2); W = c.clientWidth; var H = W * .86;
c.width = Math.round(W * dpr); c.height = Math.round(H * dpr); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
ctx.globalCompositeOperation = 'lighter'; S = W * .42 / 16; K = (32 * S) / 624; CX = W / 2; CY = W * .05 + 12 * S;
}
function hp(t) { return [16 * Math.pow(Math.sin(t), 3), 13 * Math.cos(t) - 5 * Math.cos(2 * t) - 2 * Math.cos(3 * t) - Math.cos(4 * t)]; }
function color() {
if (Math.random() < .2) return 'rgba(' + ri(235, 255) + ',' + ri(190, 215) + ',' + ri(120, 160) + ',' + rf(.10, .16).toFixed(3) + ')';
return 'rgba(' + ri(BLOOM[0][0], BLOOM[0][1]) + ',' + ri(BLOOM[1][0], BLOOM[1][1]) + ',' + ri(BLOOM[2][0], BLOOM[2][1]) + ',' + rf(.10, .17).toFixed(3) + ')';
}
function make(u) { var n = ri(8, 15), ps = []; for (var i = 0; i < n; i++) ps.push({ sa: rf(.1, 3), sb: rf(.1, 3), start: 360 / n * i, angle: 360 / n, grow: rf(.1, 1), cur: 1 }); return { ux: u[0], uy: u[1], r: rf(8, 10) * 1.15, color: color(), petals: ps, done: false }; }
function petal(p, r) {
var a = p.start * Math.PI / 180, b = p.angle * Math.PI / 180, x1 = -Math.sin(a) * r, y1 = Math.cos(a) * r;
var x2 = x1 * Math.cos(b) - y1 * Math.sin(b), y2 = x1 * Math.sin(b) + y1 * Math.cos(b);
ctx.beginPath(); ctx.moveTo(x1, y1); ctx.bezierCurveTo(x1 * p.sa, y1 * p.sa, x2 * p.sb, y2 * p.sb, x2, y2); ctx.stroke();
}
function begin(b) { ctx.save(); ctx.translate(CX + b.ux * S, CY - b.uy * S); ctx.scale(K, K); ctx.lineWidth = 1 / K; ctx.strokeStyle = b.color; }
function step() {
var busy = false;
blooms.forEach(function (b) {
if (b.done) return; begin(b); var all = true;
b.petals.forEach(function (p) { if (p.cur <= b.r) { p.cur += p.grow; petal(p, p.cur); all = false; } });
ctx.restore(); b.done = all; if (!all) busy = true;
});
return busy;
}
function redraw() {
ctx.clearRect(0, 0, c.width, c.height);
blooms.forEach(function (b) { begin(b); b.petals.forEach(function (p) { for (var r = 1; r <= b.r; r += p.grow) petal(p, r); p.cur = b.r + 1; }); ctx.restore(); b.done = true; });
}
function plan() {
var pts = [], minD = 13 * 1.15;
for (var t = Math.PI; t < 3 * Math.PI; t += .025) {
var u = hp(t), ok = true;
for (var i = 0; i < pts.length; i++) { var dx = (pts[i][0] - u[0]) * S / K, dy = (pts[i][1] - u[1]) * S / K; if (dx * dx + dy * dy < minD * minD) { ok = false; break; } }
if (ok) pts.push(u);
}
return pts;
}
var lastW = 0;
window.addEventListener('resize', function () { if (!blooms.length || Math.abs(c.clientWidth - lastW) < 2) return; lastW = c.clientWidth; cancelAnimationFrame(raf); size(); redraw(); });
return {
grow: function (done) {
size(); lastW = W; var pts = plan();
if (reduce) { blooms = pts.map(make); redraw(); done(); return; }
var i = 0, last = 0, placing = true;
function frame(ts) {
if (placing && ts - last > 3600 / pts.length) { last = ts; blooms.push(make(pts[i++])); if (i >= pts.length) placing = false; }
var busy = step(); if (placing || busy) raf = requestAnimationFrame(frame); else done();
}
raf = requestAnimationFrame(frame); setTimeout(done, 4200);
}
};
})();
var words = $('#heart-words'), started = false;
function startLove() { if (started) return; started = true; var shown = false; garden.grow(function () { if (!shown) { shown = true; words.classList.add('show'); } }); }
if ('IntersectionObserver' in window) {
var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { startLove(); io.disconnect(); } }); }, { threshold: .3 });
io.observe($('#loved'));
} else startLove();

(function () {
var g = $('#gallery'); if (!g) return;
var slides = $$('.slide', g), thumbs = $$('.thumb', g), box = $('#slides'), n = slides.length, cur = 0, heldAt = 0, inView = false;
if (n < 2) return;
function go(i, hand) {
i = (i + n) % n; if (hand) heldAt = Date.now(); if (i === cur) return;
slides[cur].classList.remove('is-active'); slides[cur].setAttribute('aria-hidden', 'true'); thumbs[cur].removeAttribute('aria-current');
cur = i; slides[cur].classList.add('is-active'); slides[cur].removeAttribute('aria-hidden'); thumbs[cur].setAttribute('aria-current', 'true');
var t = thumbs[cur], strip = t.parentNode;
if (strip.scrollWidth > strip.clientWidth) strip.scrollTo({ left: t.offsetLeft - strip.clientWidth / 2 + t.offsetWidth / 2, behavior: 'smooth' });
}
$('.g-prev', g).addEventListener('click', function () { go(cur - 1, true); });
$('.g-next', g).addEventListener('click', function () { go(cur + 1, true); });
thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i, true); }); });
var sx = null;
box.addEventListener('pointerdown', function (e) { sx = e.clientX; });
box.addEventListener('pointerup', function (e) { if (sx === null) return; var dx = e.clientX - sx; sx = null; if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1), true); });
g.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') go(cur + 1, true); if (e.key === 'ArrowLeft') go(cur - 1, true); });
if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { inView = es[0].isIntersecting; }, { threshold: .35 }).observe(g); else inView = true;
if (!reduce) setInterval(function () { if (inView && !doc.hidden && Date.now() - heldAt > 10000) go(cur + 1); }, 5000);
})();

(function () {
var card = $('#card'); if (!card) return;
var no = $('#card-no'), of = $('#card-of'), txt = $('#card-text'), btn = $('#next-reason'), idx = 0, busy = false;
function show(i) {
if (i < reasons.length) { no.textContent = i + 1; of.textContent = T.of(reasons.length); txt.textContent = reasons[i]; btn.textContent = T.another; }
else { no.textContent = '∞'; of.textContent = T.counting; txt.textContent = T.more; btn.textContent = T.restart; }
}
function next() {
if (busy) return; busy = true; card.classList.add('leaving');
setTimeout(function () { idx = (idx + 1) % (reasons.length + 1); show(idx); card.classList.remove('leaving'); card.classList.add('entering'); void card.offsetWidth; card.classList.remove('entering'); busy = false; }, reduce ? 0 : 430);
}
show(0); card.addEventListener('click', next); btn.addEventListener('click', next);
})();

(function () {
var letter = $('#letter'), unfold = $('#unfold'); if (!letter) return;
if (letter.scrollHeight <= letter.clientHeight + 20) { letter.classList.remove('folded'); $('#unfold-row').hidden = true; return; }
unfold.addEventListener('click', function () {
letter.style.maxHeight = letter.scrollHeight + 'px'; letter.classList.remove('folded'); unfold.setAttribute('aria-expanded', 'true');
setTimeout(function () { letter.style.maxHeight = 'none'; $('#unfold-row').hidden = true; }, reduce ? 0 : 1150);
});
})();

(function () {
if (!cap) return;
var when = parseDate(cap.date), cd = $('#countdown'), openBtn = $('#cap-open'), letter = $('#cap-letter'), cells = $$('b', cd);
function upd() {
var ms = when - new Date();
if (ms <= 0) { cd.hidden = true; $('#cap-when').textContent = T.capsuleReady; if (letter.hidden) openBtn.hidden = false; return false; }
var d = Math.floor(ms / 864e5); ms -= d * 864e5;
cells[0].textContent = d.toLocaleString(LANG === 'fr' ? 'fr-FR' : 'en-US'); cells[1].textContent = pad(Math.floor(ms / 36e5));
cells[2].textContent = pad(Math.floor(ms % 36e5 / 6e4)); cells[3].textContent = pad(Math.floor(ms % 6e4 / 1e3));
return true;
}
if (upd()) var t = setInterval(function () { if (!upd()) clearInterval(t); }, 1000);
openBtn.addEventListener('click', function () { openBtn.hidden = true; letter.hidden = false; });
})();

if (!reduce) doc.addEventListener('click', function (e) {
if (e.target.closest('button, a, .intro') || (!e.clientX && !e.clientY)) return;
var NS = 'http://www.w3.org/2000/svg', s = doc.createElementNS(NS, 'svg'), u = doc.createElementNS(NS, 'use');
s.setAttribute('class', 'tap-heart'); s.setAttribute('aria-hidden', 'true'); u.setAttribute('href', '#i-heart'); s.appendChild(u);
s.style.left = e.clientX + 'px'; s.style.top = e.clientY + 'px'; doc.body.appendChild(s);
s.addEventListener('animationend', function () { s.remove(); });
});
})();
